// AUTO-GENERATED from the live ester1.fi content (DatoCMS export).
// Safe to hand-edit: this is now the source of truth for site content.

const { asset } = require('./assets');

const kerrospohjat = [
  {
    id: "DatoCmsKerrospohjat-2050485-fi",
    otsikko: "1 krs",
    otsikkoMobiilissa: "1",
    kuva: asset("1614932423-1krs-uusi.jpg", {
      sizes: "(max-width: 1800px) 100vw, 1800px",
      aspectRatio: 2.156334,
    }),
  },
  {
    id: "DatoCmsKerrospohjat-2050486-fi",
    otsikko: "2 krs",
    otsikkoMobiilissa: "2",
    kuva: asset("1614933815-2krs-uusi.jpg", {
      sizes: "(max-width: 1800px) 100vw, 1800px",
      aspectRatio: 2.156334,
    }),
  },
  {
    id: "DatoCmsKerrospohjat-2050487-fi",
    otsikko: "3 krs",
    otsikkoMobiilissa: "3",
    kuva: asset("1614949677-3krs-uusi.jpg", {
      sizes: "(max-width: 1800px) 100vw, 1800px",
      aspectRatio: 2.156334,
    }),
  },
  {
    id: "DatoCmsKerrospohjat-2050490-fi",
    otsikko: "4 krs",
    otsikkoMobiilissa: "4",
    kuva: asset("1614949863-4krs-uusi.jpg", {
      sizes: "(max-width: 1800px) 100vw, 1800px",
      aspectRatio: 2.156334,
    }),
  },
  {
    id: "DatoCmsKerrospohjat-2050491-fi",
    otsikko: "5 krs",
    otsikkoMobiilissa: "5",
    kuva: asset("1614950083-5krs-uusi.jpg", {
      sizes: "(max-width: 1800px) 100vw, 1800px",
      aspectRatio: 2.156334,
    }),
  },
  {
    id: "DatoCmsKerrospohjat-2050499-fi",
    otsikko: "6 krs",
    otsikkoMobiilissa: "6",
    kuva: asset("1614950536-6krs-uusi.jpg", {
      sizes: "(max-width: 1800px) 100vw, 1800px",
      aspectRatio: 2.156334,
    }),
  },
];

module.exports = { kerrospohjat };
